import React, { Component } from "react";
import Product from "./components/product";
import HandHover from "./components/handHover";
import { getDashboardData } from "../services/dashboardServices";
import { connect } from "react-redux";
import Layout from "./components/Layout";
import Skeleton from "react-loading-skeleton";
import oxdrDiagram from "../images/Diagram_oxdr_new.png";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      dashboardData: [],
      updateDashboardData: [],
      team: "oxdr",
      showModal: false,
      dataLoaded: false,
    };
  }
  componentDidMount() {
    getDashboardData().then((json) => {
      this.setState({
        dashboardData: json,
        dataLoaded: true,
      });
    });
  }

  handleShow = () => {
    this.setState({ showModal: true });
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { dashboardData, dataLoaded } = this.state;
    return (
      <>
        <section className="dashboard">
          <Layout team="oxdr">
            {this.state.team !== "handHover" ? (
              <div className="main-pannel white-gradient">
                <div className="xdr-nav">
                  <div className="xdr-info">
                    <img src="images/invinsense_XDR_logo3.png" />
                    <p>
                      Improve your Detection and <br />
                      Response with Attacker's Actions
                    </p>
                  </div>

                  {!this.state.showModal && (
                    <div
                      className="xdr-architecture xdr-cursor"
                      onClick={this.handleShow}
                    >
                      <div className="xdr-arc-icon">
                        <img src="images/flow.png" />
                      </div>
                      <p>View Architecture</p>
                    </div>
                  )}
                  {this.state.showModal && (
                    <div
                      className="xdr-architecture close xdr-cursor"
                      onClick={this.handleClose}
                    >
                      <div className="xdr-arc-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 0 24 24"
                          width="24px"
                          fill="#000"
                        >
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </svg>
                      </div>
                      <p>Close</p>
                    </div>
                  )}
                </div>

                {this.state.showModal && (
                  <div className="justify-content-center d-flex">
                    {/* <img
                      className="diagramImg"
                      src="diagrams/Diagram_oxdr.png"
                      alt="Invinsense OXDR - Improve Your Detection and Response with Attacker’s Actions"
                    /> */}
                    <img src={oxdrDiagram} 
                      className="diagramImg" 
                      alt="Invinsense OXDR - Improve Your Detection and Response with Attacker’s Actions" 
                    />  
                  </div>
                )}
                <div
                  className="w-layout-grid card-row-1"
                  style={{
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                    opacity: "1",
                    display: "grid",
                  }}
                  id="xdr-row-1"
                >
                  {!this.state.showModal &&
                    (dataLoaded ? (
                      dashboardData?.map((prod) => {
                        if (prod.gname === "oxdr") {
                          return <Product color="redBack" product={prod} />;
                        }
                      })
                    ) : (
                      <div>
                        <Skeleton height={273} borderRadius={"24px"} />
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              <HandHover />
            )}
          </Layout>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { posts: state.posts };
};

export default connect(mapStateToProps)(Dashboard);
